import { ITransferDynamicContentSlide } from '@pcp/streaming';

/**
 * Parse a single JSON-serialized `ITransferDynamicContentSlide` (one entry of a
 * dynamicContent Y.Array) into its typed form, returning `null` on parse failure.
 *
 * Used by both `ClassroomFacade` (parsing the full snapshot for per-layer
 * Signals) and `SlidePreviewFacade` (parsing individual items inside
 * `createAppendDynamicContent$`'s backlog replay). Centralized here so the
 * parse-and-drop policy stays consistent between snapshot and event paths —
 * a corrupted entry must be invisible to both, in the same way.
 */
export function parseDynamicContentItem(json: string): ITransferDynamicContentSlide | null {
    try {
        return JSON.parse(json) as ITransferDynamicContentSlide;
    } catch {
        return null;
    }
}
